import React, { useContext, useEffect, useState } from 'react'
import './QuizPage.css'
import backBtn from '../../assets/img/v2/back.png'
import { baseUrl, categoryEventId, dataContext, portal } from '../../App';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import QuestionBody from './QuestionBody/QuestionBody';
import BlockRound from './BlockRound/BlockRound';
import ResultModal from './ResultModal/ResultModal';
import { pushCleverTapEvent } from '../../helper/clevertapFunction';
import { apiUrl } from '../../api.config';
import { fetchUserPlayingHistory } from '../../services';
import NewyearPurchaseModal from '../../components/Modal/NewyearPurchaseModal/NewyearPurchaseModal';
import { fakeRules } from '../../assets/fakeData';
const QuizPage = () => {
  const navigate = useNavigate()
  const {token, setToken, playerData, setPlayerData} = useContext(dataContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const eventId = parseInt(searchParams.get("eventId"))
  const [eventDetails, setEventDetails] = useState({})
  const [showQuestions, setShowQuestions] = useState(false)
  const [showBlockModal, setShowBlockModal] = useState(false)
  const [showResultModal, setShowResultModal] = useState(false)
  const [showNewyearPurchaseModal, setShowNewyearPurchaseModal] = useState(false)
  const [finalScore, setFinalScore] = useState(0)
  const [playerRound, setPlayerRound] = useState(null)
  const [onDemandPurchaseTimes, setOnDemandPurchaseTimes] = useState(0)
  const [isLoadingEnd, setIsLoadingEnd] = useState(false)
  const [roundChecked, setRoundChecked] = useState(false)
  const [fetchRequest, setFetchRequest] = useState(false)
  const [userPlayingHistoryData, setUserPlayingHistoryData] = useState([])

  function insertData(isRight, mobile, round, questionId, selectedAns, category, eventId, ondemand=0) {
    // insert Data Function
    // console.log(isRight, mobile, round, questionId, selectedAns, category, eventId)
    axios.post(`${baseUrl}/api/participant/`, {
      is_right: isRight,
      msisdn: mobile,
      round_number: round,
      question: questionId,
      selected_answer: selectedAns,
      category: category,
      event: eventId,
      portal: portal,
      ondemand: ondemand
    }, {
      headers: { Authorization: `Token ${token}` }
    });
  }

  useEffect(() => {
    if (token && eventId && playerData?.id) {
      fetchUserPlayingHistory(token)
        .then(response => {
          console.log('response of playing history', response)
          setUserPlayingHistoryData(response)
          // setPlayerData(response.data[0])
          // console.log(data);
          const config = {
            headers: { Authorization: `Token ${token}` },
          };
          if(categoryEventId.includes(eventId)||eventId === 145){
            axios.get(`${apiUrl.getEventRules}?portal=${portal}&is_event=false`,config)
            .then(response => {
              const allEvent = response.data || [];
              let eventDe = allEvent.filter(event => {
                return (event?.id === eventId)
              })
              if(!eventDe.length){
                navigate('../')
              }else{
                setEventDetails(eventDe[0])
                setIsLoadingEnd(true)
              }
            })
          }
          else if (playerData?.isSubscribe && eventId===34) {
            axios.get(`${apiUrl.getEventRules}?portal=${portal}`,config)
            .then(response => {
              const allEvent = response.data || [];
              let eventDe = allEvent.filter(event => {
                return (event?.id === eventId)
              })
              if(!eventDe.length){
                navigate('../')
              }else{
                setEventDetails(eventDe[0])
                setIsLoadingEnd(true)
              }
          })
          }else if (playerData?.isSubscribeSports && eventId === 75) {
            axios.get(`${apiUrl.getEventRules}?portal=${portal}`,config)
            .then(response => {
              const allEvent = response.data || [];
              let eventDe = allEvent.filter(event => {
                return (event?.id === eventId)
              })
              if(!eventDe.length){
                navigate('../')
              }else{
                setEventDetails(eventDe[0])
                setIsLoadingEnd(true)
              }
          })
          }
          else if (playerData?.isSubscribeTournament && (eventId === 150)) {
            axios.get(`${apiUrl.getEventRules}?portal=${portal}`,config)
            .then(response => {
              const allEvent = response.data || [];
              let eventDe = allEvent.filter(event => {
                return (event?.id === eventId)
              })
              if(!eventDe.length){
                navigate('../')
              }else{
                setEventDetails(eventDe[0])
                setIsLoadingEnd(true)
              }
          })
          }else if (playerData?.isSubscribeBcs && eventId === 149) {
            axios.get(`${apiUrl.getEventRules}?portal=${portal}`,config)
            .then(response => {
              // const allEvent = response.data || [];
              const allEvent = fakeRules;
              let eventDe = allEvent.filter(event => {
                return (event?.id === eventId)
              })
              if(!eventDe.length){
                navigate('../')
              }else{
                setEventDetails(eventDe[0])
                setIsLoadingEnd(true)
              }
            })
          }else{navigate('../')}
        }).catch(res => {
          // console.log(res.response.status === 401)
          // localStorage.setItem("AuthToken", "");
          // localStorage.setItem("user_msisdn", "");
          // setPlayerData({});
          // setShowLoginModal(true);
          // setToken(null);
          navigate('../')
        });
    }else{
      navigate('../')
    }

  }, [])
  useEffect(() => {
    if (isLoadingEnd) {
      let playerLeaderboardArr = userPlayingHistoryData?.event_history;
      console.log('playerLeaderboardArr', playerLeaderboardArr,userPlayingHistoryData)
      let playerRoundNum = 0;
      let playerLeaderboard = []
      if(playerLeaderboardArr){playerLeaderboard = playerLeaderboardArr.filter((a)=>{if(a.event_id==eventDetails.id){return a}});}
      playerRoundNum = (playerLeaderboard.length)?playerLeaderboard[0]?.round_number__max : 0;
      let eventRound = eventDetails?.round
      setPlayerRound(playerRoundNum)
      // console.log(playerRoundNum,eventRound,eventDetails)
      if (playerRoundNum < eventRound) {
        setShowQuestions(true)
        // if(eventId == 34){pushCleverTapEvent('StartPlay-QuizPratidin')}
        // else if(eventId == 75){pushCleverTapEvent('StartPlay-SportsQuiz')}
        // else if(eventId == 77){pushCleverTapEvent('StartPlay-WinterQuiz')}
        sessionStorage.setItem('played_eventId', eventId);
      } else {
        if(eventId == 80){
          let onDemandPurchaseToday = playerData?.new_year_tournament?.ondemand_purchase_today||0;
          let onDemandRound = onDemandPurchaseToday * 2;
          let onDemandPlayedRound = playerData?.new_year_tournament?.ondemand_play_today||0;
          if(onDemandRound > onDemandPlayedRound){
            setShowQuestions(true)
            setOnDemandPurchaseTimes(onDemandPurchaseToday)
          }else{
            if(playerData?.new_year_tournament?.day_spend > playerData?.new_year_tournament?.play_days){
              setShowNewyearPurchaseModal(true)
            }else{
              setShowBlockModal(true)
            }
          }
        }else{
          (playerData.msisdn === '1867125111'
            || playerData.msisdn === '1738246580'
            || playerData.msisdn === '1711082515'
          )?setShowQuestions(true):setShowBlockModal(true);
        }
      }
    }
  }, [isLoadingEnd])
  // CustomEvents Background and Element

  return (
    <div className='quizPageBody' style={{background:'#f5f5f5'}}>

      {(showQuestions) && (<QuestionBody insertData={insertData} eventDetails={eventDetails} finalScore={finalScore} setFinalScore={setFinalScore} setShowResultModal={setShowResultModal} playerRound={playerRound} onDemandPurchaseTimes={onDemandPurchaseTimes}></QuestionBody>)}
      {showBlockModal && (<BlockRound eventDetails={eventDetails} showBlockModal={showBlockModal} setShowBlockModal={setShowBlockModal}></BlockRound>)}
      {showResultModal && (<ResultModal eventDetails={eventDetails} showResultModal={showResultModal} setShowResultModal={setShowResultModal} finalScore={finalScore}></ResultModal>)}
      {showNewyearPurchaseModal && (
        <NewyearPurchaseModal
          showNewyearPurchaseModal={showNewyearPurchaseModal}
          setShowNewyearPurchaseModal={setShowNewyearPurchaseModal}
        ></NewyearPurchaseModal>
      )}
    </div>
  )
}

export default QuizPage